export const FACEBOOK_URL = 'https://www.facebook.com/p/Le-Domaine-du-Haras-de-La-Chaine-100054275179925'
export const INSTAGRAM_URL = 'https://www.instagram.com/domaineduharasdelachaine'
export const MARIAGE_NET_URL = 'https://www.mariages.net/domaine-mariage/le-domaine-du-haras-de-la-chaine--e169070'
